import { BookingPrivateSources } from "./BookingPrivateSources";

export const BookingPrivateSourcesLabels = {
  [BookingPrivateSources.BANK_TRANSFER]: "Bank transfer",
  [BookingPrivateSources.CASH]: "Cash / Cheque",
  [BookingPrivateSources.VOUCHER]: "3rd party voucher",
  [BookingPrivateSources.OTHER]: "Other"
};
